<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{ $t('userAccounts') }}</h3>
      <div class="tile-body">
        <user-invite :roles="roles" v-if="$store.state.user.permissions.includes('userManageAll')"></user-invite>
        <user :roles="roles"></user>
      </div>
    </div>
  </div>
</template>

<script>
import User from "./User";
import UserInvite from "./UserInvite";

export default {
  components: {User, UserInvite},
  data() {
    return {
      roles: []
    }
  },
  methods: {
    getRoles() {
      this.roles =  [
        {value: null, text: this.$t('chooseRole')},
        {value: 'owner', text: this.$t('owner')},
        {value: 'supervisor', text: this.$t('supervisor')},
        {value: 'agent', text: this.$t('agent')},
      ]
      this.$service.get('/role', {params: {
        page: 1, pageSize: 100
        }}).then(response => {
        if (response && response.data) {
          response.data.docs.forEach(d => {
            if (!this.roles.find(r => r.value === d.key)) {
              this.roles.push({value: d.key, text: d.name})
            }
          })
        }
      })
    }
  },
  mounted() {
    this.getRoles();
  }
}
</script>